const KEY = 'ccpm_gantt_state';
const VERSION = 1;

const DEFAULT_COLUMNS = ['id', 'text', 'duration', 'resource', 'cc'];

export function loadGanttState() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.version !== VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveGanttState(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...state, version: VERSION }));
  } catch {
    // Quota exceeded or storage unavailable — fail silently.
  }
}

export function defaultGanttState() {
  return {
    version:        VERSION,
    selectedIds:    null,            // null = use built-in default (active+queued+paused)
    fever:          ['green', 'yellow', 'red'],
    statusActive:   true,
    statusDone:     false,
    ccOnly:         false,
    visibleColumns: [...DEFAULT_COLUMNS],
    scale:          'week',          // 'hour' | 'day' | 'week' | 'month' | 'quarter'
    columnWidths:   {},              // { id: 40, text: 220, ... } — overrides COLUMN_DEFS defaults
    gridWidth:      420,             // ширина таблицы (splitter позиция), 1..максимум
    showCurrentInBaselineMode: true,  // Чекбокс «Current» в edit-mode: ON = призрак, OFF = скрыт
  };
}
